export const CLEAR_STORE_DATA = 'CLEAR_STORE_DATA';
export const CLEAR_LOGIN_DATA = 'CLEAR_LOGIN_DATA';
export const RECOVER_FROM_ERROR_STATE = 'RECOVER_FROM_ERROR_STATE';
